import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack5';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, TreeView, TreeItem } from '@material-ui/lab';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  Box,
  Card,
  Grid,
  Stack,
  Select,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Checkbox,
  Chip,
  MenuItem,
  ListItemText,
  FormControlLabel,
  Typography,
  Switch,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Icon,
  CardHeader,
  styled
} from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
import Label from 'src/components/Label';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
import CaseConvertor from '../../common-components/CaseConvertor';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
import {
  createUserRole,
  updateUserRole,
  resetCreateUserRoleStatus,
  resetUserRoleError
} from '../../../redux/slices/user_role';
// ----------------------------------------------------------------------

AddUserRoleForm.propTypes = {
  editId: PropTypes.number,
  setVisibleComponent: PropTypes.func,
  currentUserRole: PropTypes.object,
  moduleList: PropTypes.array
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

export default function AddUserRoleForm({ editId, currentUserRole = {}, setVisibleComponent }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { error, createUserRoleStatus, moduleList, isLoading } = useSelector((state) => state.user_role);

  const editTempData = {
    editProfileName: currentUserRole.access_profile_name ? currentUserRole.access_profile_name : '',
    editPermissions: currentUserRole.module_wise_permissions ? currentUserRole.module_wise_permissions : []
  };
  const initObj = editId ? JSON.parse(JSON.stringify(editTempData.editPermissions)) : [];
  const [permissionsArr, setPermissionArr] = useState(initObj);

  const testModuleList = Object.keys(moduleList);

  useEffect(() => {
    if (error || createUserRoleStatus) {
      enqueueSnackbar(
        (createUserRoleStatus && (!editId ? 'New User Role Created Successfully' : 'User Role Updated Successfully')) ||
          (error && error),
        { variant: error ? 'error' : 'success' }
      );
      dispatch(resetUserRoleError());
    }
    if (createUserRoleStatus) {
      setVisibleComponent('List');
      formik.resetForm();
      dispatch(resetCreateUserRoleStatus());
    }
  }, [error, createUserRoleStatus]);

  const NewUserSchema = Yup.object().shape({
    profileName: Yup.string().required('Profile Name is required')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      profileName: editId ? editTempData.editProfileName : '',
      permissions: editId ? editTempData.editPermissions : []
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const roleData = {
          access_profile_name: CaseConvertor(values.profileName),
          module_wise_permissions: permissionsArr
        };
        dispatch(!editId ? createUserRole(roleData) : updateUserRole(roleData, editId));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setErrors(error);
      }
    }
  });

  // const handleChange = (event) => {
  //   const {
  //     target: { value }
  //   } = event;
  //   // setModuleName(
  //   //   // On autofill we get a stringified value.
  //   //   typeof value === 'string' ? value.split(',') : value
  //   // );
  //   formik.setFieldValue('permissions', typeof value === 'string' ? value.split(',') : value);
  // };

  const { errors, values, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  const handleMasterCheckbox = (event) => {
    const { name, checked } = event.target;
    // console.log('checked', checked);
    if (checked) {
      const tempMasterData = moduleList[name].map((d) => d);

      const tempppp = permissionsArr.filter((item) => !tempMasterData.includes(item));

      const neew = tempMasterData.concat(tempppp);
      setPermissionArr(neew);
    } else if (!checked) {
      const tempMasterData = moduleList[name].map((d) => d);

      const difference = permissionsArr.filter((item) => !tempMasterData.includes(item));

      setPermissionArr(difference);
    }
  };

  const handleSingleCheckBox = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      if (!permissionsArr.includes(value)) {
        const temppermissionArr = permissionsArr;
        temppermissionArr.push(value);
        setPermissionArr(temppermissionArr);

        const justLikeThat = permissionsArr.filter((da) => da !== 'a');
        setPermissionArr(justLikeThat);
      }
    } else if (!checked) {
      const temppermissionArr = permissionsArr.filter((da) => da !== value);
      setPermissionArr(temppermissionArr);
    }
  };

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="Access Profile Name"
                    {...getFieldProps('profileName')}
                    error={Boolean(touched.profileName && errors.profileName)}
                    helperText={touched.profileName && errors.profileName}
                  />
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  {/* <FormControl>
                    <InputLabel id="Module-wise-permission">Module Wise Permission</InputLabel>
                    <Select
                      labelId="Module-wise-permission"
                      id="Module-wise-permission"
                      multiple
                      value={values?.permissions ? values?.permissions : null}
                      onChange={handleChange}
                      input={<OutlinedInput label="Module Wise Permission" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {permissionsArr.length > 0 &&
                        permissionsArr.map((name) => (
                          <MenuItem sx={{ paddingBottom: '3px', paddingTop: '3px' }} key={name} value={name}>
                            <Checkbox checked={values.permissions.indexOf(name) > -1} />
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl> */}

                  <Typography variant="subtitle1"> Module Access</Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="space-evenly">
                    {/* Master Data */}
                    <Card elevation={12} sx={{ minWidth: '100%', p: 3 }}>
                      <Grid container direction={{ xs: 'row', md: 'row', lg: 'row' }} spacing={2}>
                        {testModuleList.map((module, index) => (
                          <Grid item xs={3} md={3} key={index}>
                            <Stack direction="column" sx={{ ml: 2 }}>
                              <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center">
                                <Checkbox
                                  onChange={handleMasterCheckbox}
                                  name={module}
                                  checked={moduleList[module].every((i) => permissionsArr.includes(i))}
                                />
                                <Typography variant="subtitle1" sx={{ display: 'flex' }}>
                                  {' '}
                                  {module}
                                </Typography>
                              </Stack>
                              <Divider />
                              <Stack direction="column" sx={{ marginLeft: 2 }}>
                                {moduleList[module].map((master, index) => (
                                  <FormControlLabel
                                    key={index}
                                    label={master}
                                    control={
                                      <Checkbox
                                        name={master}
                                        value={master}
                                        checked={permissionsArr.includes(master)}
                                        onChange={handleSingleCheckBox}
                                      />
                                    }
                                  />
                                ))}
                              </Stack>
                            </Stack>
                          </Grid>
                        ))}
                      </Grid>
                    </Card>
                  </Stack>
                </Stack>

                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton type="submit" variant="contained" loading={isLoading}>
                    {!editId ? 'Save' : 'Save Changes'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
